import axios, {useContext} from "axios";

import { getNewAcessTokenApi } from "./authApi";

const ApiUrl = process.env.REACT_APP_API_URL;



const axiosInstance = axios.create({
 baseURL: `${ApiUrl}`,
  withCredentials: true, 
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers["x-access-token"] = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);




/* ================= RESPONSE ================= */

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;
    const code = error.response?.data?.code;

    if (
      code === "ACCESS_TOKEN_EXPIRED" &&
      !originalRequest._retry &&
      !originalRequest.url.includes("get/new-acess-token")
    ) {
      originalRequest._retry = true;

      try {
        const refreshRes = await getNewAcessTokenApi();
        const { accessToken, user } = refreshRes;


        // console.log("Api called from axoi instance -reefsee tokeon api");

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("user", JSON.stringify(user));

        originalRequest.headers["x-access-token"] = accessToken;
        return axiosInstance(originalRequest);

      } catch (err) {
                console.log("Api called from axoi instance  FAILED fAILD ");

        localStorage.clear();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);






export default axiosInstance;




